import { Product } from "../Model/Product";
import { ProductRepository } from "../Repository/ProductRepository";



export interface UpdateProductUseCase {
    invoke: (data: Product) => Promise<boolean>;
  }
  
  export class UpdateProduct implements UpdateProductUseCase {
    private productRepo: ProductRepository;
    constructor(_ProductRepo: ProductRepository) {
      this.productRepo = _ProductRepo;
    }
  
    async invoke(data: Product){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.productRepo.updateProduct(data);
        return update;
    }
  }